<template>
    <el-dialog
        :title="isForm ? '编辑服务' : '详情'"
        :model-value="modelValue"
        width="640px"
        @opened="dialogOpened"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="formRules"
            label-width="150px"
            label-suffix="："
            style="max-width: 560px"
        >
            <el-form-item label="通信协议" prop="communication_protocol">
                <el-select v-model="formData.communication_protocol" placeholder="请选择" style="width: 100%" v-if="isForm">
                    <el-option label="HTTP" :value="1"></el-option>
                    <el-option label="MQTT" :value="2"></el-option>
                </el-select>
                <span v-else>{{ formData.communication_protocol === 1 ? 'HTTP' : 'MQTT' }}</span>
            </el-form-item>
            <el-form-item label="推送地址" prop="url">
                <el-input v-model="formData.url" placeholder="请输入推送地址" v-if="isForm" />
                <span v-else>{{ formData.url }}</span>
            </el-form-item>
            <el-form-item label="推送IP" prop="ip">
                <el-input v-model="formData.ip" placeholder="请输入推送IP" v-if="isForm" />
                <span v-else>{{ formData.ip }}</span>
            </el-form-item>
            <el-form-item label="推送地址端口" prop="port">
                <el-input v-model="formData.port" placeholder="请输入推送地址端口" v-if="isForm" />
                <span v-else>{{ formData.port }}</span>
            </el-form-item>
            <el-form-item label="鉴权账号" prop="account">
                <el-input v-model="formData.account" placeholder="请输入鉴权账号" autocomplete="off" v-if="isForm" />
                <span v-else>{{ formData.account }}</span>
            </el-form-item>
            <el-form-item label="鉴权密码" prop="password">
                <el-input v-model="formData.password" placeholder="请输入鉴权密码" autocomplete="new-password" show-password />
            </el-form-item>
            <el-form-item label="推送频率" prop="minute">
                <div class="input-number" v-if="isForm">
                    <el-input-number v-model="formData.hour" :min="0" :max="72" placeholder="请输入" />
                    <span style="margin-left: 10px">小时</span>
                    &nbsp;&nbsp;
                    <el-input-number v-model="formData.minute" :min="0" :max="60" placeholder="请输入" />
                    <span style="margin-left: 10px">分钟</span>
                </div>
                <span v-else>{{ formData.hour }}小时{{ formData.minute }}分钟</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer" v-if="isForm">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
            <span class="dialog-footer" v-else>
                <el-button type="primary" @click="closed">关闭</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { updatePushSet } from '@/api/heating/monitoring.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    modelId: {
        type: String,
        required: false
    },
    detailData: {
        type: Object,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

const loading = ref(false)

// 弹窗打开
function dialogOpened() {
    loading.value = true
    const data = props.detailData
    if (data.rate >= 0) {
        data.hour = Math.floor(data.rate / 60)
        data.minute = data.rate % 60
    }
    // 将data中的值赋值给formData，但是不增加数据
    Object.keys(data).forEach((key) => {
        if (formData.value.hasOwnProperty(key)) {
            formData.value[key] = data[key]
        }
    })
    loading.value = false
}

// 表单源
const formData = ref({
    id: '',
    type: 1,
    building: '',
    communication_protocol: '',
    url: '',
    ip: '',
    port: '',
    account: '',
    password: '',
    hour: 0,
    minute: 30
})

// 验证规则
const formRules = ref({
    communication_protocol: [{ required: true, message: '请选择通信协议', trigger: 'blur' }],
    url: [{ required: true, message: '请输入推送地址', trigger: 'blur' }],
    ip: [
        { required: true, message: '请输入推送IP', trigger: 'blur' },
        {
            pattern: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
            message: '请输入正确的推送IP',
            trigger: 'blur'
        }
    ],
    port: [
        { required: true, message: '请输入推送地址端口', trigger: 'blur' },
        {
            pattern: /^[1-9]\d*$/,
            message: '请输入正确的推送地址端口',
            trigger: 'blur'
        }
    ],
    account: [{ required: true, message: '请输入鉴权账号', trigger: 'blur' }],
    password: [{ required: true, message: '请输入鉴权密码', trigger: 'blur' }],
    minute: [{ required: true, message: '请输入推送频率', trigger: 'blur' }]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
function onConfirm() {
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            const data = { ...formData.value }
            data.port = Number(data.port)
            data.rate = data.hour * 60 + data.minute
            delete data.hour
            delete data.minute
            await updatePushSet(data)
            emits('updateForm')
            ElMessage.success('操作成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}
</script>

<style lang="scss" scoped></style>
